import script from "./ReliableSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ReliableSection.vue?vue&type=script&setup=true&lang=js"

import "./ReliableSection.vue?vue&type=style&index=0&id=27cece0d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27cece0d"]])

export default __exports__